
import { Placement } from '@post-office/placements-frontend/project-assets-ai-suggestions';
export default Placement;
